<template>
  <div class="users">
    <template v-if="tableItems.length">
      <p class="users__title h3">
        Список пользователей
      </p>

      <div class="users__panel">
        <BaseInput
          v-model="searchValue"
          placeholder="Поиск по всем параметрам"
          isSearch
          class="users__input"
          @enter="onSearch"
        />

        <BaseButton
          theme="light"
          class="users__btn"
          href="/create-user"
        >
          + Добавить пользователя
        </BaseButton>
      </div>

      <AppTable
        :fields="tableFields"
        :items="tableItems"
        class="users__table"
        @sort="onSortTable"
      >
        <template #name="{ id, name }">
          <BaseLink :href="`/user/${id}`">
            {{ name }}
          </BaseLink>
        </template>
      </AppTable>

      <div class="users__bottom">
        <RouterLink to="black-list" class="users__link">
          Посмотреть черный список
        </RouterLink>
        <AppPagination
          v-if="(paginationTotal / paginationPerPage) > 1"
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
        />
      </div>
    </template>

    <p v-else class="h3">Список пользователей пуст.</p>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput'
import AppTable from '@/components/AppTable'
import BaseButton from '@/components/Base/BaseButton'
import AppPagination from '@/components/Base/AppPagination'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'users',
  components: {
    BaseLink,
    AppPagination,
    BaseButton,
    AppTable,
    BaseInput
  },
  data () {
    /**
     * @property {Array} tableFields                                  - Заголовки таблицы
     * @property {Array} tableItems                                   - Контент таблицы
     * @property {String} searchValue                                 - Поле поиска
     * @property {Number} paginationCurrent                           - текущая страница
     * @property {Number} paginationTotal                             - общее кол-во записей в бд
     * @property {Number} paginationPerPage                           - количество строк в таблице
     * @property {String} order                                       - сортировка по возрастанию\убыванию
     * @property {String} sort                                        - свойство по которому будет сортировка
     */
    return {
      tableFields: [
        { key: 'name', label: 'Имя', sortable: true, slot: true },
        { key: 'username', label: 'Логин', sortable: true },
        { key: 'email', label: 'Почта', sortable: true },
        { key: 'role', label: 'Роль' },
        { key: 'createdAt', label: 'Дата', sortable: true }
      ],
      tableItems: [],
      searchValue: '',
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    fetchUsersRequestBody () {
      return {
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        searchBy: this.searchValue,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    /**
     * Отслеживанию изменение св-ва и подтягиваю новые данные таблицы
     */
    paginationCurrent: 'fetchUsers'
  },
  async created () {
    await this.fetchUsers()
  },
  methods: {
    /**
     * Подтягиваю данные таблицы по api
     */
    async fetchUsers () {
      try {
        const { data } = await this.$api.user.users(this.fetchUsersRequestBody)

        const result = []
        const list = data.list ?? []
        /* Записал общее колво пользователей */
        this.paginationTotal = data.pages * this.paginationPerPage

        for (const item of list) {
          const roles = item?.role.map(i => i?.label || '')
          result.push({
            id: item.id,
            name: item.name,
            username: item.username,
            email: item.email,
            role: roles.join(', '),
            createdAt: item.createdAt
          })
        }

        this.tableItems = result
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Записал новое значение поиска
     */
    async onSearch () {
      await this.fetchUsers()
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
.users {
  &__panel {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  &__input {
    max-width: 640px;
  }
  &__btn {
    padding: 0 20px;
  }

  &__table {
    margin-top: 40px;
  }

  &__bottom {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__link {
    display: block;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    color: #C2C2C2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
